import { ArticleVideoPlayer, Block } from '@benzinga/content-manager';
import { NativoAdPlacementType } from './nativo/entities';

interface AdBlockParamsI {
  id: string;
  height: number;
  width: number;
  placementId: string;
}

export const getAdBlock = (params?: Partial<AdBlockParamsI>) => {
  const { height, id, placementId, width } = params || {};

  return {
    attrs: {
      data: {
        id: id ?? 'in-article-ga-placeholder',
        slot_height: height ?? 250,
        slot_placement_id: placementId ?? '/4107070/DotCom_300x250_InArticle',
        slot_width: width ?? 300,
      },
    },
    blockName: 'acf/google-ad-placement',
  };
};

export const getRaptiveAdBlock = (params?: Partial<AdBlockParamsI>): Block => {
  const { id } = params || {};

  return {
    attrs: {
      className: 'min-w-[300px]',
      data: {
        //ad_light_hidden: true,
        id: id ?? 'in-article-raptive-placeholder',
        //only_client_side: true,
        //only_desktop: true,
        //no_wrapper: true,
        type: 'content',
      },
    },
    blockName: 'acf/raptive-ad-placement',
  };
};

export const getNativoAdBlock = (params?: Partial<AdBlockParamsI>): Block => {
  const { id } = params || {};

  return {
    attrs: {
      //className: 'h-[175px]',
      data: {
        id: id ?? 'in-article-nativo-placeholder',
        type: 'in-content-article-page' as NativoAdPlacementType,
      },
    },
    blockName: 'acf/nativo-ad-placement',
  };
};

export const getConnatixBlock = (
  params?: Partial<{ channels?: string[]; video_player?: ArticleVideoPlayer }>,
): Block => {
  const { channels } = params || {};

  return {
    attrs: {
      data: {
        non_live_widget: {
          attrs: {
            data: {
              channels,
            },
          },
          blockName: 'acf/connatix-block',
        },
      },
    },
    blockName: 'acf/connatix-live-block',
  };
};

interface CampaignifyBlockParams {
  nodeId?: number;
  strategy: string;
  ticker: string;
  position: 'middle' | 'bottom';
}

export const createCampaignifyBlock = (params: Partial<CampaignifyBlockParams>) => {
  return {
    blockName: 'ad/campaignify',
    nodeID: params.nodeId,
    position: params.position,
    strategy: params.strategy,
    ticker: params.ticker,
  } as unknown as Block;
};

export const createOptimizelyCampaignifyBlock = (params: Partial<CampaignifyBlockParams>) => {
  return {
    blockName: 'ad/optimizely-campaignify',
    nodeID: params.nodeId,
    position: params.position,
  } as unknown as Block;
};
